import { useState, useEffect } from 'react';
import { apiFetch } from '../api';

function QuoteOfDay({ refreshKey }) {
  const [quote, setQuote] = useState(() => {
    try {
      const cached = localStorage.getItem('meware_quote');
      if (cached) return JSON.parse(cached);
    } catch {}
    return null;
  });
  const [loading, setLoading] = useState(!quote);
  const [favorites, setFavorites] = useState([]);
  const [showFavorites, setShowFavorites] = useState(false);

  useEffect(() => {
    async function fetchQuote() {
      try {
        const res = await apiFetch('/api/quote');
        if (!res.ok) return;
        const data = await res.json();
        if (Array.isArray(data) && data.length > 0 && data[0].q) {
          const newQuote = { text: data[0].q, author: data[0].a };
          setQuote(newQuote);
          localStorage.setItem('meware_quote', JSON.stringify(newQuote));
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    fetchQuote();
    fetchFavorites();
  }, [refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps

  async function fetchFavorites() {
    try {
      const res = await apiFetch('/api/quote/favorites');
      if (res.ok) setFavorites(await res.json());
    } catch {}
  }

  async function toggleFavorite() {
    if (!quote) return;
    const isFav = favorites.some(f => f.text === quote.text && f.author === quote.author);
    if (isFav) {
      const res = await apiFetch(`/api/quote/favorites?text=${encodeURIComponent(quote.text)}&author=${encodeURIComponent(quote.author)}`, { method: 'DELETE' });
      if (res.ok) setFavorites(await res.json());
    } else {
      const res = await apiFetch('/api/quote/favorites', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text: quote.text, author: quote.author }),
      });
      if (res.ok) setFavorites(await res.json());
    }
  }

  async function removeFavorite(fav) {
    const res = await apiFetch(`/api/quote/favorites?text=${encodeURIComponent(fav.text)}&author=${encodeURIComponent(fav.author)}`, { method: 'DELETE' });
    if (res.ok) setFavorites(await res.json());
  }

  if (loading) return <section className="card"><h2>Quote of the Day</h2><p className="loading">Loading...</p></section>;
  if (!quote) return <section className="card"><h2>Quote of the Day</h2><p className="empty">No quote available</p></section>;

  const isFav = favorites.some(f => f.text === quote.text && f.author === quote.author);

  return (
    <section className="card quote-section">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2 style={{ margin: 0 }}>Quote of the Day</h2>
        <div style={{ display: 'flex', gap: 6 }}>
          {favorites.length > 0 && (
            <button onClick={() => setShowFavorites(!showFavorites)}
              style={{ background: 'none', border: 'none', color: '#71717a', cursor: 'pointer', fontSize: 12 }}>
              {showFavorites ? 'Hide' : `Favorites (${favorites.length})`}
            </button>
          )}
        </div>
      </div>
      <div style={{ position: 'relative' }}>
        <blockquote className="quote-text">"{quote.text}"</blockquote>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <cite className="quote-author">— {quote.author}</cite>
          <button onClick={toggleFavorite} title={isFav ? 'Remove from favorites' : 'Save to favorites'}
            style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, padding: 0 }}>
            {isFav ? '\u2764\uFE0F' : '\u2661'}
          </button>
        </div>
      </div>
      {showFavorites && favorites.length > 0 && (
        <div style={{ marginTop: 12, borderTop: '1px solid #2a2b35', paddingTop: 10 }}>
          <h3 style={{ fontSize: 13, color: '#a1a1aa', margin: '0 0 8px' }}>Saved Quotes</h3>
          {favorites.map((fav, i) => (
            <div key={i} style={{ marginBottom: 10, padding: '8px 10px', background: '#16171f', borderRadius: 6, fontSize: 13 }}>
              <div style={{ color: '#e4e4e7', fontStyle: 'italic' }}>"{fav.text}"</div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 4 }}>
                <span style={{ color: '#71717a', fontSize: 12 }}>— {fav.author}</span>
                <button onClick={() => removeFavorite(fav)}
                  style={{ background: 'none', border: 'none', color: '#52525b', cursor: 'pointer', fontSize: 14 }}>&times;</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export default QuoteOfDay;
